/**
 * Registers the k-anonymity thresholds at `/privacy`, order 70.
 */

import { createElement } from 'react';
import { ShieldCheck } from 'lucide-react';

import type { OpsRouteBundle } from '../routes/contract';
import { OpsShell } from '../shell/OpsShell';
import { Privacy } from './Privacy';
import { t } from './messages';

export const bundle: OpsRouteBundle = {
  order: 70,
  routes: [
    {
      path: '/privacy',
      element: createElement(OpsShell, null, createElement(Privacy)),
      kind: 'data',
    },
  ],
  nav: [{ path: '/privacy', label: () => t('nav.label'), icon: ShieldCheck, kind: 'data' }],
};
